export enum EvseStatus {
  NEW = 'new',
  RESERVED = 'reserved',
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
  FAULTED = 'faulted',
  CHARGING = 'charging',
}
